import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../../../context/AppContext";
import "../../../../assets/css/patient/patientlayouts/layoutpages/PatientProfile.css";

const PatientProfile = () => {
  const { baseUrl, user } = useContext(AppContext);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = localStorage.getItem("userId");


  const authHeaders = () => {
    const token = localStorage.getItem("patient_token");
    return { Authorization: `Bearer ${token}`, Accept: "application/json" };
  };

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    axios
      .get(`${baseUrl}/Patient/PatientAuth/getProfile/${userId}`, {
        headers: authHeaders(),
      })
      .then((response) => {
        if (response.data?.success) {
          setProfile(response.data.data);
        } else {
          setError("Profile not found");
        }
      })
      .catch(() => setError("Could not load your profile"))
      .finally(() => setLoading(false));
  }, [baseUrl, userId]);

  const getInitials = (name) => {
    if (!name) return "P";
    return name.split(" ").map((n) => n[0]).join("").substring(0, 2).toUpperCase();
  };

  if (loading) {
    return <div className="pp-container">Loading your profile...</div>;
  }

  const displayName = profile?.full_name || user?.name || "Patient";

  return (
    <div className="pp-container">
      <div className="pp-header">
        <div className="pp-avatar">{getInitials(displayName)}</div>
        <div>
          <h2>{displayName}</h2>
          <p>{profile?.email || user?.email}</p>
        </div>
        <Link to="/patientdashboard/mysettings" className="pp-edit-btn">
          Edit Profile
        </Link>
      </div>

      {error && <p className="pp-error">{error}</p>}

      {!error && !profile && (
        <div className="pp-empty">
          <p>You haven't set up your profile yet.</p>
          <Link to="/patientdashboard/mysettings" className="pp-edit-btn">
            Complete your profile
          </Link>
        </div>
      )}

      {profile && (
        <div className="pp-details-grid">
          <div className="pp-detail-item">
            <span className="pp-label">Phone</span>
            <span className="pp-value">{profile.phone || "—"}</span>
          </div>
          <div className="pp-detail-item">
            <span className="pp-label">Date of Birth</span>
            <span className="pp-value">{profile.date_of_birth || "—"}</span>
          </div>
          <div className="pp-detail-item">
            <span className="pp-label">Gender</span>
            <span className="pp-value">{profile.gender || "—"}</span>
          </div>
          <div className="pp-detail-item">
            <span className="pp-label">City</span>
            <span className="pp-value">{profile.city || "—"}</span>
          </div>
          <div className="pp-detail-item">
            <span className="pp-label">Country</span>
            <span className="pp-value">{profile.country || "—"}</span>
          </div>
          <div className="pp-detail-item">
            <span className="pp-label">Preferred Language</span>
            <span className="pp-value">{profile.language || "—"}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientProfile;